<template>
   <el-dialog
    title="Configure available time"
    :visible.sync="dialog_visible"
    @open="onLoad"
    width="75%">

    <div class="d-block timepref-modal">

      <h3> Select time you want to commit to achieving your vision </h3>

      <el-radio-group v-model="clone.mode">
        <el-radio-button label="simple">I want to start easy</el-radio-button>
        <el-radio-button label="advanced">I want more advanced settings</el-radio-button>
      </el-radio-group>

      <template v-if="clone.mode === 'simple'">
        <el-card class="box-card">
          <div class="sub-title">On average, how many hours per week you want to commit to your goals?</div>
          <el-slider v-model="clone.cachedHoursAvailable" :min="4" :step="0.5" :max="40" show-input></el-slider>

          <div class="mt-4 ml-4">
            {{commitmentTime[1]}} hours per day<br />
            {{commitmentTime[2]}} hours per 30 days
          </div>
        </el-card>

      </template>
      <template v-else>
        <el-card>

          <h5>Determine your unavailable time</h5>

          <div class="sub-title">On average, how many hours per day do you sleep?</div>
          <el-slider v-model="clone.hoursSleep" :min="4" :step="0.5" :max="12" show-input></el-slider>

          <el-radio-group>
            <el-radio-button label="1">I work for a company</el-radio-button>
            <el-radio-button label="2">I'm self-employed</el-radio-button>
          </el-radio-group>

          <div class="sub-title">On average, how many hours per day do you spend on your day job (incl. commuting)?</div>
          <el-form ref="form" label-width="120px" @submit.native.prevent>
            <el-form-item
              v-for="(val,idx) in clone.timeSpentAtJob"
              :key="'time-spent-at-job-'+idx"
              class="m-0"
              :label="weekdays[idx]">
              <el-slider
                v-model="clone.timeSpentAtJob[idx]"
                :min="0" :step="0.5" :max="12" show-input>{{idx}}</el-slider>
            </el-form-item>
          </el-form>

          <div class="sub-title">On average, how many hours per day do you spend on  other major neccessities? (cooking, eating, cleaning,  buying groceries, etc.)</div>
          <el-form ref="form" label-width="120px" @submit.native.prevent>
            <el-form-item
              v-for="(val,idx) in clone.timeSpendOtherwise"
              :key="'time-spent-otherwise-'+idx"
              class="m-0"
              :label="weekdays[idx]">
              <el-slider
                v-model="clone.timeSpendOtherwise[idx]"
                :min="0" :step="0.5" :max="12" show-input>{{idx}}</el-slider>
            </el-form-item>
          </el-form>

          <p>
            Total: <strong>{{totalHours}}</strong> of <strong>{{hoursPerWeek}}</strong> hours per week spend otherwise
          </p>

          <!-- <h5>Weekly Availability Summary</h5> -->
          <div>
            You have <strong>{{hoursAvailable}} hours / week available</strong> to work on achieving your goals.
          </div>
        </el-card>

        <el-card class="box-card mt-3">

          <el-row>
            <el-col :span="12">
              <div class="sub-title">How much of you free time do you want to use to make your dreams become reality?</div>
              <el-slider v-model="clone.weeklyCommitmentRate" :min="0" :step="0.01" :max="1"></el-slider>
            </el-col>
            <el-col :span="12">
              <div class="mt-4 ml-4">
                = {{commitmentTime[1]}} hours per day<br />
                = {{commitmentTime[0]}} hours per week<br />
                = {{commitmentTime[2]}} hours per 30 days
              </div>
            </el-col>
          </el-row>

          Commitment level:
          <el-rate
            v-model="commitmentLevel"
            disabled
            show-score
            text-color="#ff9900"
            score-template="{value} points">
          </el-rate>
          <el-tag>{{commitmentLevelText}}</el-tag>

          <h3 class="m-4 p-4">...loading bar here</h3>

        </el-card>
      </template>

      <el-card class="box-card mt-3">
        <el-switch
          v-model="clone.freeTimeMethod"
          active-text="Look at my calendar"
          inactive-text="Specify time">
        </el-switch>

        <template v-if="clone.freeTimeMethod">

          <p class="mt-6"> Ok! We will look at your calendar. But how should we determine free time? </p>

          <el-radio-group v-model="clone.calendarFreeTimeMethod">
            <el-radio :label="0">Look at non blocked time during my work time<sup>1</sup></el-radio>
            <el-radio :label="1">Look at special, that has the word 'WORK' in it</el-radio>
          </el-radio-group>

          <div>
             <sup>1</sup> G Suite only. How to setup, see: <a target="_blank" href="https://support.google.com/calendar/answer/7638168?hl=de">here</a>
          </div>

        </template>
        <template v-else>

          <div class="sub-title">When do you want to start?</div>
          <!-- TODO: this component can not handle user timezone -->
          <el-time-select
            v-model="clone.startTime"
            :picker-options="timePickerOptions"
            placeholder="Select time">
          </el-time-select>

          <div class="sub-title">When do you want to stop?</div>
          <!-- TODO: this component can not handle user timezone -->
          <el-time-select
            v-model="clone.endTime"
            :picker-options="timePickerOptions"
            placeholder="Select time">
          </el-time-select>

        </template>
      </el-card>

      <!-- <pre>{{clone}}</pre> -->
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveSettings">OK</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import util from '@/util'

export default {
  data() {
    return {
      dialog_visible: false,
      isReady: false,
      weekdays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
      clone: {
        mode: 'simple',
        cachedHoursAvailable: 8,
        freeTimeMethod: true,
        calendarFreeTimeMethod: 0
      },
      timePickerOptions: {
        start: '04:30',
        step: '00:15',
        end: '22:00'
      }
    }
  },
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),

    hoursAvailable() {
      if ( this.mode === 'simple' ) {
        return this.clone.cachedHoursAvailable;
      } else {
        if ( !this.isReady ) {
          return -1;
        }
        return this.hoursPerWeek - this.totalHours;
      }
    },

    commitmentTime() {
      if ( !this.isReady ) {
        return [-1, -1, -1];
      }
      let committedHours = this.clone.weeklyCommitmentRate * this.hoursAvailable;
      return [
        (committedHours ).toFixed(2),
        (committedHours / 7).toFixed(2),
        ((committedHours / 7) * 30).toFixed(2)
     ];
    },

    commitmentLevel() {
      if ( !this.isReady ) {
        return -1;
      }
      return parseFloat( ( this.clone.weeklyCommitmentRate * 5 ).toFixed(1) );
    },

    commitmentLevelText() {
      if ( this.commitmentLevel > 4.9 ) return "To the max!";
      if ( this.commitmentLevel > 4.0 ) return "Noice";
      if ( this.commitmentLevel > 3.0 ) return "Average";
      return "Lame";
    },

    totalHours() {
      if ( !this.isReady ) {
        return -1;
      }

      let hoursSleep = this.clone.hoursSleep;
      let sumTimeSpentAtJob = util.listsum( this.clone.timeSpentAtJob )
      let sumTimeSpendOtherwise = util.listsum( this.clone.timeSpendOtherwise )

      return sumTimeSpentAtJob + sumTimeSpendOtherwise + hoursSleep * 7;
    },

    hoursPerWeek() {
      return 24 * 7;
    }
  },
  methods: {
    showModal() {
      this.dialog_visible = true;
    },

    onLoad() {
      if ( this.userData  && 'availabilitySettings' in this.userData) {
        let settings = this.userData.availabilitySettings;
        this.clone = Object.assign({}, settings)

        this.clone.timeSpendOtherwise = [];
        Object.keys(settings.timeSpendOtherwise).forEach(key => {
          this.clone.timeSpendOtherwise.push(settings.timeSpendOtherwise[key]);
        });

        this.clone.timeSpentAtJob = [];
        Object.keys(settings.timeSpentAtJob).forEach(key => {
          this.clone.timeSpentAtJob.push(settings.timeSpentAtJob[key]);
        });

        console.log("onLoad", this.userData, this.clone);
        this.isReady = true;
      }
    },

    onSaveSettings() {
      console.log("onSaveSettings", this.clone);

      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'availabilitySettings'
      }).then(() => {
        console.log( "Successfully updated user availabilitySettings" );
        this.dialog_visible = false;
        this.$emit('save');
      });
    },
  }
};
</script>

<style >
.timepref-modal h5 {
  margin-top: 2em;
}
</style>
